import Vue from 'vue'
import Router from 'vue-router'
import Login from './../views/Login'
import {index} from "./index/index"
import AppNote from "@/views/common/AppNote.vue"
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/appnote',
      name: 'AppNote',
      component: AppNote
    },
    index
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js